export const DEPARTMENTS_URL = Object.freeze({
  path: '/departments',
  view: {
    name: 'department.view',
    path: '/departments/view/:id',
  },
  edit: {
    name: 'department.edit',
    path: '/departments/edit/:id',
  },
  forbidden: {
    name: 'department.forbidden',
    path: '/department/forbidden',
  },
});
